import { useRouter } from 'next/router';
import { getBCP47Language, getSafeLocale, getSafeLocaleForSanity } from 'shared/utils/locale';

export function useLocale() {
  const router = useRouter();
  // IMPORTANT: prefer a value that exists on both server and client (SSR-stable)
  const raw = router.locale ?? router.defaultLocale ?? 'en-us';
  return getSafeLocale(raw);
}

export function useLocaleForSanity() {
  const router = useRouter();
  return getSafeLocaleForSanity(router.locale);
}

export function useBCP47Locale() {
  const locale = useLocale();
  return getBCP47Language(locale);
}
